export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4598.6a689a9f.jpg";